const transformCentralizedOrgData = (data)=>{
    if (!data) return;
    if ('CentralizedOrganizationTenantNode' === data.__typename) {
        const brandingVersion = 'CentralizedOrganizationTenantPaletteColorsV1Node' === data.branding.palette_colors.__typename ? 'v1' : 'v1';
        return {
            id: Number(data.id),
            slug: data.slug,
            name: data.name,
            branding: {
                paletteColors: {
                    [brandingVersion]: {
                        darkest: data.branding.palette_colors.darkest,
                        dark: data.branding.palette_colors.dark,
                        base: data.branding.palette_colors.base,
                        light: data.branding.palette_colors.light,
                        lightest: data.branding.palette_colors.lightest
                    }
                },
                imageLogo: {
                    id: data.branding.image_logo.id,
                    absoluteUrl: data.branding.image_logo.absolute_url
                },
                imageFavicon: {
                    id: data.branding.image_favicon.id,
                    absoluteUrl: data.branding.image_favicon.absolute_url
                },
                imageIsotype: {
                    id: data.branding.image_isotype.id,
                    absoluteUrl: data.branding.image_isotype.absolute_url
                },
                imagePageLoginHero: {
                    id: data.branding.image_page_login_hero.id,
                    absoluteUrl: data.branding.image_page_login_hero.absolute_url
                }
            }
        };
    }
};
export { transformCentralizedOrgData };
